import axios from '../../../axios';
import IJobPostAtJobTargetDTO from '../types/IJobPostAtJobTargetDTO';

const url = 'jobsearch/api/jobs/';

export const getJobDetailsAtJobTarget = (jobId: string) =>
  axios.get(`${url}job-details-at-job-target/${jobId}`);

export const postJobToJobTarget = (jobTargetDTO: IJobPostAtJobTargetDTO) =>
  axios.post(`${url}job-target`, jobTargetDTO);
